var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogin(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 786.138,
    height: 437.714,
    viewBox: "0 0 786.138 437.714",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_254",
    "data-name": "Ellipse 254",
    cx: 40.873,
    cy: 40.873,
    r: 40.873
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "login",
    transform: "translate(-372.498 -279.627)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_617",
    "data-name": "Group 617",
    transform: "translate(989.634 466.427)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_602",
    "data-name": "Group 602",
    transform: "translate(17.209)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_458",
    "data-name": "Path 458",
    d: "M1208.572,569.879s27.719-2.53,53.982-13.292c.831-.343,1.334,5.3,1.334,5.3s3.864-7.545,5.213-8.178c14.214-6.707,27.254-16.05,34.243-28.984,0,0,3.445,79.315-98.513,96.928Z",
    transform: "translate(-1204.83 -524.73)",
    fill: "#5084da"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_603",
    "data-name": "Group 603",
    transform: "translate(7.118 135.621)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_459",
    "data-name": "Path 459",
    d: "M1239.33,702.68s33.648,17.834,99.443,20.936c0,0-44.76,40.85-147.182,26.789l3.361-46.52Z",
    transform: "translate(-1191.59 -702.68)",
    fill: "#5084da"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_604",
    "data-name": "Group 604",
    transform: "translate(7.789 60.3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_460",
    "data-name": "Path 460",
    d: "M1192.47,633.893s15.189-9.7,39.844-18.078c.983-.335,3.064,5.48,3.064,5.48s3.369-7.568,5.144-8.1c29.456-8.818,69.758-14.58,113.161-2.324,0,0-13.147,18.322-40.065,38.373-1.143.854-8.749.183-8.749.183s3.193,3.849,2.142,4.573a257.668,257.668,0,0,1-109.2,43.076Z",
    transform: "translate(-1192.47 -603.85)",
    fill: "#5193f4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_610",
    "data-name": "Group 610",
    transform: "translate(0 67.311)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_605",
    "data-name": "Group 605"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_461",
    "data-name": "Path 461",
    d: "M1351.252,613.05A378.375,378.375,0,0,1,1311.629,635c-13.581,6.638-27.551,12.468-41.689,17.811-7.057,2.713-14.275,4.977-21.439,7.4l-10.86,3.254c-1.814.534-3.612,1.105-5.442,1.6l-5.5,1.379a369.391,369.391,0,0,1-44.447,8.742l11.089-2.286,5.541-1.12c1.837-.4,3.666-.892,5.495-1.334l10.99-2.622,10.891-3.01c7.278-1.936,14.427-4.329,21.629-6.509,7.111-2.477,14.275-4.8,21.286-7.553,14.153-5.152,28.046-10.99,41.734-17.277q10.277-4.7,20.364-9.8Q1341.4,618.621,1351.252,613.05Z",
    transform: "translate(-1182.25 -613.05)",
    fill: "#5084da"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_606",
    "data-name": "Group 606",
    transform: "translate(76.96 8.444)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_462",
    "data-name": "Path 462",
    d: "M1283.23,658.2c2.812-2.629,5.533-5.3,8.254-7.957,2.7-2.683,5.358-5.388,7.911-8.185,2.584-2.774,5-5.678,7.385-8.627,2.324-2.988,4.527-6.074,6.63-9.306a49.857,49.857,0,0,1-5.236,10.3,76.477,76.477,0,0,1-7.156,9.107A80.832,80.832,0,0,1,1283.23,658.2Z",
    transform: "translate(-1283.23 -624.13)",
    fill: "#5084da"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_607",
    "data-name": "Group 607",
    transform: "translate(36.209 22.132)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_463",
    "data-name": "Path 463",
    d: "M1229.76,674.709a73.866,73.866,0,0,0,8.5-6.615,66.181,66.181,0,0,0,7.362-7.69,62.563,62.563,0,0,0,6.1-8.7,93.118,93.118,0,0,0,4.885-9.61,40.855,40.855,0,0,1-3.369,10.411,43.5,43.5,0,0,1-5.929,9.29,45.114,45.114,0,0,1-7.972,7.606A36.109,36.109,0,0,1,1229.76,674.709Z",
    transform: "translate(-1229.76 -642.09)",
    fill: "#5084da"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_608",
    "data-name": "Group 608",
    transform: "translate(76.96 40.233)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_464",
    "data-name": "Path 464",
    d: "M1283.23,668.126a141.73,141.73,0,0,0,15.593-.076c2.576-.137,5.129-.434,7.69-.808,2.576-.335,5.091-.922,7.72-1.4a29.337,29.337,0,0,1-7.362,3.071,38.063,38.063,0,0,1-7.9,1.318,42.454,42.454,0,0,1-7.995-.229A30.494,30.494,0,0,1,1283.23,668.126Z",
    transform: "translate(-1283.23 -665.84)",
    fill: "#5084da"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_609",
    "data-name": "Group 609",
    transform: "translate(37.039 54.805)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_465",
    "data-name": "Path 465",
    d: "M1230.85,684.96c3.171.381,6.31.686,9.428,1.006,3.132.282,6.249.549,9.367.678,3.117.152,6.234.137,9.351.053,3.117-.168,6.227-.45,9.389-.937a34.733,34.733,0,0,1-9.229,2.645,55.545,55.545,0,0,1-9.61.434A58.666,58.666,0,0,1,1230.85,684.96Z",
    transform: "translate(-1230.85 -684.96)",
    fill: "#5084da"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_612",
    "data-name": "Group 612",
    transform: "translate(28.481 20.608)",
    opacity: 0.228
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_611",
    "data-name": "Group 611"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_466",
    "data-name": "Path 466",
    d: "M1296.389,551.77c-2.713,7.438-7.5,14-12.933,19.77a85.876,85.876,0,0,1-18.748,14.648L1259.449,589c-1.745.953-3.62,1.639-5.426,2.462a97.374,97.374,0,0,1-11.18,4.047c-1.867.671-3.826,1.029-5.739,1.517l-5.769,1.372c-3.91.61-7.812,1.181-11.714,1.677,3.826-.983,7.675-1.761,11.478-2.721l5.64-1.661c1.867-.579,3.78-1.021,5.586-1.783,3.635-1.433,7.378-2.584,10.868-4.344,1.753-.846,3.6-1.517,5.3-2.469l5.129-2.8a99.346,99.346,0,0,0,18.649-13.932c1.4-1.357,2.812-2.706,4.07-4.192.64-.732,1.318-1.44,1.936-2.195l1.806-2.3A57.408,57.408,0,0,0,1296.389,551.77Z",
    transform: "translate(-1219.62 -551.77)",
    fill: "#605aca",
    opacity: 0.5
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_616",
    "data-name": "Group 616",
    transform: "translate(22.65 149.751)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_613",
    "data-name": "Group 613"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_467",
    "data-name": "Path 467",
    d: "M1322.128,733.627c-4.611.884-9.275,1.433-13.939,1.982q-7.008.674-14.054,1.029a241.792,241.792,0,0,1-28.2-.4c-4.687-.4-9.374-.937-14.023-1.684a128.088,128.088,0,0,1-13.856-2.782,96.02,96.02,0,0,1-26.088-10.555,102.728,102.728,0,0,0,13,5.236,124.979,124.979,0,0,0,13.482,3.681,197.583,197.583,0,0,0,27.658,3.925c9.29.823,18.642,1,27.978.907C1303.433,734.847,1312.785,734.428,1322.128,733.627Z",
    transform: "translate(-1211.97 -721.22)",
    fill: "#4ca1ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_614",
    "data-name": "Group 614",
    transform: "translate(35.889 11.706)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_468",
    "data-name": "Path 468",
    d: "M1289.233,753.72a35.222,35.222,0,0,1-18.009-3.559,27.751,27.751,0,0,1-7.53-5.579,20.945,20.945,0,0,1-4.634-8,34.367,34.367,0,0,0,5.83,6.775,37.325,37.325,0,0,0,7.324,4.847,56.723,56.723,0,0,0,8.254,3.277A85.228,85.228,0,0,0,1289.233,753.72Z",
    transform: "translate(-1259.06 -736.58)",
    fill: "#4ca1ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_615",
    "data-name": "Group 615",
    transform: "translate(15.784 7.034)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_469",
    "data-name": "Path 469",
    d: "M1258.425,753.718a35.2,35.2,0,0,1-16.813-7.377,27.823,27.823,0,0,1-6.143-7.073,21.026,21.026,0,0,1-2.789-8.818,34.672,34.672,0,0,0,4.222,7.88,37.369,37.369,0,0,0,6.1,6.318,56.849,56.849,0,0,0,7.347,4.992A88.006,88.006,0,0,0,1258.425,753.718Z",
    transform: "translate(-1232.68 -730.45)",
    fill: "#4ca1ff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_618",
    "data-name": "Group 618",
    transform: "translate(667.83 623.213)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_470",
    "data-name": "Path 470",
    d: "M877.1,820.77a54.725,54.725,0,0,0-41.437-18.581c-11.539.152-22.864,3.986-34.372,3.277a43.935,43.935,0,0,1-40.835-50.186c1.334-9.123,6.1-18.276,14.366-22.361a27.724,27.724,0,0,1,14.7-2.324,41.509,41.509,0,0,1,13.208,3.529c9.549,4.237,17.857,11.706,24.495,19.953,6.028,7.5,19.792,18.535,29.1,25.653,5.457,4.161,9.389,6.974,9.389,6.974C872.263,792.777,872.606,813.042,877.1,820.77Z",
    transform: "translate(-760.007 -730.451)",
    fill: "#52d2bc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_471",
    "data-name": "Path 471",
    d: "M781.02,767.3c28.991,8.261,61.016,19.96,83.651,39.867",
    transform: "translate(-765.006 -739.216)",
    fill: "none",
    stroke: "#00ad9f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_619",
    "data-name": "Group 619",
    transform: "translate(798.294 625.22)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_472",
    "data-name": "Path 472",
    d: "M1003.57,755.084a36.734,36.734,0,0,1-3.75,14.115,31.632,31.632,0,0,1-6.28,7.995,47.291,47.291,0,0,1-4.024,3.407,58.6,58.6,0,0,1-17.6,9.229c-9.069,2.888-18.771,3.422-27.1,8.528a32.944,32.944,0,0,0-13.589,17.018l-.038-8.117c.892-8.993,1.8-18.146,5.152-26.736a75.909,75.909,0,0,1,8.7-15.677,108.788,108.788,0,0,1,18.969-21.332c5.853-4.939,12.552-9.13,19.709-10.2s14.747,1.57,18.024,7.873C1003.852,745.237,1004,750.252,1003.57,755.084Z",
    transform: "translate(-931.19 -733.084)",
    fill: "#5193f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_473",
    "data-name": "Path 473",
    stroke: "#0b43a4",
    d: "M937.8,802.206a67.315,67.315,0,0,1,24.647-29.746c6.692-4.4,14.031-7.4,20.859-11.516s13.413-9.717,16.614-17.224",
    fill: "none",
    transform: "translate(-932.762 -735.614)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1,
    opacity: 0.31
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_620",
    "data-name": "Group 620",
    transform: "translate(780.902 676.874)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_474",
    "data-name": "Path 474",
    d: "M919.642,823.19c12.75-12.651,30.843-18.451,48.624-21,14.831-2.126,30.409-2.2,44.28,3.453,4.344,1.776,8.635,4.237,11.2,8.17s2.934,9.6-.206,13.086c-2.645,2.942-6.951,3.658-10.906,3.8-13.025.465-25.768-3.315-38.526-5.99-21.926-4.6-45.8-5.708-65.741,4.519",
    transform: "translate(-908.37 -800.859)",
    fill: "#52d2bc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_475",
    "data-name": "Path 475",
    d: "M944.03,819.327c26.393-11.127,64.514-7.545,81.144,3.963",
    transform: "translate(-916.852 -803.649)",
    fill: "none",
    stroke: "#00ad9f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_623",
    "data-name": "Group 623",
    transform: "translate(372.498 528.118)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_476",
    "data-name": "Path 476",
    d: "M495.9,640.653c-11.927-5.731-17.643-21-27.444-24.281-12.141-4.2-15.547,9.367-35.188,6.013-16.477-2.812-21.484-21.347-49.035-15.616-8.414,1.753-13.993,8.864-10.837,17.392,2.363,8.49,14.054,13.856,21,18.192,6.166,3.483,11.63,5.35,15.288,11.828a1.865,1.865,0,0,1,.107.213c2.462,5.266,1.479,9.961,7.225,13.81,13.452,9.839,30.211-5.785,45.522-5.327,10.792.32,10.495,11.531,23.474,14.778,12.857,3.216,8.635-8.292,35.607,2.157a1.875,1.875,0,0,0,2.431-1.082h0a1.884,1.884,0,0,0-.4-1.974C504.775,656.993,513.448,649.09,495.9,640.653Z",
    transform: "translate(-372.498 -605.676)",
    fill: "#4a84d8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_477",
    "data-name": "Path 477",
    d: "M495.9,640.653c-11.927-5.731-17.643-21-27.444-24.281-12.141-4.2-15.547,9.367-35.188,6.013-16.477-2.812-21.484-21.347-49.035-15.616-8.414,1.753-13.993,8.864-10.837,17.392,2.363,8.49,14.054,13.856,21,18.192,6.166,3.483,11.63,5.35,15.288,11.828a1.865,1.865,0,0,1,.107.213c2.462,5.266,1.479,9.961,7.225,13.81,13.452,9.839,30.211-5.785,45.522-5.327,10.792.32,10.495,11.531,23.474,14.778,12.857,3.216,8.635-8.292,35.607,2.157a1.875,1.875,0,0,0,2.431-1.082h0a1.884,1.884,0,0,0-.4-1.974C504.775,656.993,513.448,649.09,495.9,640.653Z",
    transform: "translate(-372.498 -605.676)",
    fill: "#00ad9f"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_622",
    "data-name": "Group 622",
    transform: "translate(14.858 11.945)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_621",
    "data-name": "Group 621"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_478",
    "data-name": "Path 478",
    d: "M515.745,670.538c-8.444-4.138-13.734-12.346-21.286-17.7-3.651-2.584-7.911-4.6-12.453-4.672-4.885-.084-9.8,2.37-14.618.678-3.742-1.311-6.509-4.382-9.984-6.2a11.066,11.066,0,0,0-5.823-1.326c-2.523.137-4.954.976-7.476,1.128-4.268.259-8.269-1.479-11.8-3.742-3.658-2.347-6.928-5.236-10.426-7.8a49.094,49.094,0,0,0-26.263-9.481c-1.151-.061-2.309-.084-3.468-.061-.282.008-.16.747.16.747a48.508,48.508,0,0,1,27.254,7.934c3.643,2.4,6.913,5.312,10.449,7.858,3.285,2.363,6.92,4.535,10.99,5.152a19.51,19.51,0,0,0,6.714-.358c2.363-.465,4.763-.953,7.141-.32,3.833,1.021,6.669,4.077,10.014,6.028a12.323,12.323,0,0,0,5.914,1.806,38.538,38.538,0,0,0,7.339-.93,19.193,19.193,0,0,1,7.194.023,22.342,22.342,0,0,1,6.371,2.523c8.079,4.619,13.276,12.735,21.042,17.758a28.438,28.438,0,0,0,2.934,1.661c.343.16.328-.579.076-.7Z",
    transform: "translate(-391.993 -621.349)",
    fill: "#4ca1ff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_624",
    "data-name": "Group 624",
    transform: "translate(430.991 630.666)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_479",
    "data-name": "Path 479",
    d: "M630.255,752.843c-39.234,4.146-45.514,7.537-54.919,3.468-11.988-5.182-24.586-3.895-36.674-8.848s-25.211-8.734-38.1-6.646c-4.077.663-8.6,2.317-9.168,7.1a7.816,7.816,0,0,0,1.517,5.426c2.843,3.963,7.477,5.289,11.912,6.516l14.831,4.093c4.824,1.334,4.519,8.437-.434,9.146a.661.661,0,0,1-.122.015c-4.154.564-8.361-.259-12.461-1.166-8.909-1.974-17.834-4.375-26.957-4.382-11.043-.015-22.742,3.971-28.206,14.267a18.954,18.954,0,0,0-1.974,11.965c1.921,11.386,12.575,15.189,22.01,14.336,6.638-.6,12.918-3.163,19.19-5.434,15.319-5.541,28.42.572,44.707.991C580.343,804.859,630.255,752.843,630.255,752.843Z",
    transform: "translate(-449.248 -740.23)",
    fill: "#7ee8d4",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_480",
    "data-name": "Path 480",
    d: "M465.59,793.139c27.94-3.193,56.078-6.425,82.882-14.923,7.865-2.492,17.986-3.178,40.179-19.556",
    transform: "translate(-453.135 -744.614)",
    fill: "none",
    stroke: "#00ad9f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_627",
    "data-name": "Group 627",
    transform: "translate(435.497 386.292)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_481",
    "data-name": "Path 481",
    d: "M508.364,550.461a16.117,16.117,0,0,0,2.919,1.814c4.794,2.363,10.289,2.69,14.1,7,2.546,2.706,3.925,6.341,5.83,9.557a17.19,17.19,0,0,0,1.3,2.043c5.9,8.086,11.7,9.024,17.91,8.886,2.546-.061,5.182-.3,7.9-.3a26.287,26.287,0,0,1,13.314,3.14,36.238,36.238,0,0,1,9.45,7.69,1.981,1.981,0,0,0,2.507.168,2.141,2.141,0,0,0,.976-2.172,29.938,29.938,0,0,0-8.818-16.05c-10.99-10.4-27.216-11.226-28.2-32.7-.206-4.6.77-7.858.038-11.135a11.576,11.576,0,0,0-2.812-5.152c-3.323-3.582-8.1-5.167-12.362-8.025-11.523-8.223-6.036-21.675-7.057-34.479-.686-10.449-10.083-17.247-17.765-23.169-9.6-7.073-9.58-19.815-16.066-29.3-6.47-9.481-22.574-13.3-31.141-.564-9.1,12.72-4.1,28.626-1.486,41.521a30.093,30.093,0,0,0,3.445,9.092c4.794,8.376,13.025,14.336,20.135,21.431a50.918,50.918,0,0,1,10.586,14.862,43.441,43.441,0,0,1,3.285,10.411c.152.861.32,1.715.488,2.561C498.51,536.553,500.461,544.517,508.364,550.461Z",
    transform: "translate(-455.16 -419.584)",
    fill: "#7ee8d4"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_626",
    "data-name": "Group 626",
    transform: "translate(12.606 8.093)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_625",
    "data-name": "Group 625"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_482",
    "data-name": "Path 482",
    d: "M471.7,430.5c.251,6.6.534,13.337,2.454,19.7a29.342,29.342,0,0,0,3.986,8.437,35.533,35.533,0,0,0,5.586,6.036c4.138,3.673,8.841,6.859,12.263,11.272a20.856,20.856,0,0,1,3.727,7.9c.716,2.82,1.311,5.876,3.361,8.079,2.065,2.21,5.076,3.209,7.377,5.137a21.317,21.317,0,0,1,4.855,6.166c2.584,4.695,4.032,9.915,6.4,14.709a27.372,27.372,0,0,0,4.161,6.341c2.126,2.34,5.129,3.864,6.707,6.684,1.6,2.858,1.76,6.3,2.081,9.489a33.524,33.524,0,0,0,1.989,8.978c4.984,12.689,17.361,19.922,29.037,25.562,1.585.77,3.178,1.517,4.771,2.263.351.168.335-.572.084-.694-12-5.647-25.234-11.836-31.91-24.007a27.941,27.941,0,0,1-3.148-9.085c-.488-3.071-.5-6.211-1.219-9.252a13.773,13.773,0,0,0-1.555-4,13.632,13.632,0,0,0-3.048-3.331,36.771,36.771,0,0,1-3.468-3.064,21.688,21.688,0,0,1-2.37-3.087c-2.866-4.466-4.375-9.618-6.5-14.442a33.432,33.432,0,0,0-3.742-6.684,19.273,19.273,0,0,0-5.64-5.038,26.531,26.531,0,0,1-4.1-2.683,9.586,9.586,0,0,1-2.568-4.039c-1-2.8-1.334-5.792-2.614-8.5-2.294-4.855-6.486-8.376-10.54-11.722-4.466-3.689-8.955-7.393-11.615-12.667-3.01-5.975-3.75-12.827-4.123-19.419-.091-1.646-.16-3.285-.221-4.931,0-.4-.473-.625-.457-.114Z",
    transform: "translate(-471.7 -430.203)",
    fill: "#4ca1ff"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_483",
    "data-name": "Path 483",
    d: "M584.449,613.415a26.288,26.288,0,0,1,13.314,3.14c.427-6.585,2.637-7.957,4.116-10.365-10.99-10.4-27.216-11.226-28.2-32.7-.206-4.6.77-7.858.038-11.135-3.277,6.882-9.161,8.3-8.7,15.326.4,7.248,9.671,13.962,11.333,23.108C577.719,608.347,580.508,610.275,584.449,613.415Z",
    transform: "translate(-481.286 -453.546)",
    fill: "#5a4fd1",
    opacity: 0.37
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_628",
    "data-name": "Group 628",
    transform: "translate(620.724 651.987)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_484",
    "data-name": "Path 484",
    d: "M722.481,770.579c-7.416-2.927-17.308-4.131-22.064,2.271-3.978,5.358-1.921,12.949.831,19.03,2.317,5.137,5.266,10.35,10.159,13.139,3.346,1.905,7.263,2.477,11.081,2.934a266.159,266.159,0,0,0,32.124,1.86c12.438-.038,27.513,5.045,37.8,12.8C779.207,798.061,747.426,780.433,722.481,770.579Z",
    transform: "translate(-698.199 -768.205)",
    fill: "#5084da"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_485",
    "data-name": "Path 485",
    stroke: "#0b43a4",
    d: "M712.99,792.26c9.435.4,18.954,1.067,28.016,3.742,9.26,2.736,44.889,19.084,50.453,26.05",
    fill: "none",
    transform: "translate(-701.717 -773.927)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1,
    opacity: 0.31
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_631",
    "data-name": "Group 631",
    transform: "translate(997.283 378.103)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_486",
    "data-name": "Path 486",
    d: "M1202.212,502.513a15.018,15.018,0,0,0-.3,3.27c.015,5.114,2.073,9.961.008,15.06-1.235,3.331-3.757,6.059-5.708,9.062a16.988,16.988,0,0,0-1.2,1.989c-4.42,8.5-2.751,13.863.008,19.129,1.135,2.157,2.469,4.314,3.62,6.631a25.14,25.14,0,0,1,2.972,12.743,34.61,34.61,0,0,1-2.568,11.371,1.9,1.9,0,0,0,.93,2.218,2.057,2.057,0,0,0,2.279-.091,28.657,28.657,0,0,0,10-14.381c4.23-13.84-1.966-28.092,16.012-38.076,3.849-2.134,7.057-2.683,9.557-4.71a11.087,11.087,0,0,0,3.216-4.6c1.654-4.375.976-9.138,1.616-14.008,2.134-13.375,16-14.4,26.53-20.715,8.658-5.038,10.487-15.982,12.286-25.082,1.966-11.234,12.9-16.645,18.261-26.233,5.373-9.58,1.791-25-12.773-26.918-14.77-2.378-26.271,8.665-36.209,16.4a28.643,28.643,0,0,0-6.326,6.821c-5.137,7.675-6.737,17.262-9.793,26.37a48.935,48.935,0,0,1-8.223,15.4,41.961,41.961,0,0,1-7.522,7.248c-.671.5-1.326,1.006-1.989,1.509C1209.932,488.155,1203.942,493.215,1202.212,502.513Z",
    transform: "translate(-1192.286 -408.839)",
    fill: "#7ee8d4"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_630",
    "data-name": "Group 630",
    transform: "translate(13.873 6.622)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_629",
    "data-name": "Group 629"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_487",
    "data-name": "Path 487",
    d: "M1294.118,417.552c-5.282,2.881-10.647,5.823-15.143,9.877a29.212,29.212,0,0,0-5.5,6.509,31.226,31.226,0,0,0-3.155,7.652c-1.532,5.411-2.2,11.18-4.763,16.249a20.842,20.842,0,0,1-5.3,6.509c-2.043,1.745-4.291,3.513-5.251,6.12-1.082,2.934-.564,6.188-1.44,9.176a21.753,21.753,0,0,1-3.3,6.455c-2.934,4.1-6.707,7.515-9.74,11.539a25.383,25.383,0,0,0-3.567,6.2c-1.113,2.911-1.135,6.2-3.041,8.78-1.677,2.271-4.177,3.78-6.531,5.251a34.74,34.74,0,0,0-6.882,5.3c-9.123,9.565-10.129,23.519-10.007,36.049.015,1.783.053,3.567.091,5.35.008.389.48.617.465.107-.274-13.071-.579-27.612,7.781-38.541a27.424,27.424,0,0,1,6.432-6.051,73.411,73.411,0,0,0,6.9-4.664,12.374,12.374,0,0,0,2.561-2.9,13.661,13.661,0,0,0,1.547-4.222,24.248,24.248,0,0,1,2.873-7.568c2.629-4.276,6.341-7.728,9.534-11.562a31.741,31.741,0,0,0,4.032-5.906,19.149,19.149,0,0,0,1.951-7.294,18.273,18.273,0,0,1,.755-5.053,9.884,9.884,0,0,1,2.469-3.559c1.981-1.959,4.306-3.521,6.021-5.746,3.353-4.344,4.474-9.9,5.693-15.121a59.018,59.018,0,0,1,2.309-8.04,25.429,25.429,0,0,1,4.39-7.347c3.872-4.542,9.046-7.8,14.191-10.708,1.288-.732,2.591-1.448,3.894-2.157.251-.137.038-.861-.267-.694Z",
    transform: "translate(-1210.488 -417.527)",
    fill: "#4ca1ff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_634",
    "data-name": "Group 634",
    transform: "translate(939.081 636.395)",
    opacity: 0.51
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_488",
    "data-name": "Path 488",
    d: "M1141.184,787.86c11.295,6.371,15.906,21.675,25.28,25.508,11.607,4.885,15.807-8.162,34.791-3.62,15.936,3.811,19.64,22.262,46.947,18.421,8.338-1.174,14.26-7.766,11.714-16.31-1.768-8.452-12.849-14.458-19.373-19.145-5.807-3.8-11.028-5.983-14.191-12.545-.031-.069-.068-.145-.091-.213-2.065-5.3-.808-9.831-6.173-13.97-12.529-10.487-29.921,3.719-44.859,2.286-10.533-1.014-9.519-11.95-22-15.959-12.362-3.971-8.978,7.553-34.685-4.4a1.854,1.854,0,0,0-2.454.9h0a1.838,1.838,0,0,0,.259,1.951C1133.548,771.307,1124.562,778.486,1141.184,787.86Z",
    transform: "translate(-1115.918 -747.747)",
    fill: "#4a84d8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_489",
    "data-name": "Path 489",
    d: "M1141.184,787.86c11.295,6.371,15.906,21.675,25.28,25.508,11.607,4.885,15.807-8.162,34.791-3.62,15.936,3.811,19.64,22.262,46.947,18.421,8.338-1.174,14.26-7.766,11.714-16.31-1.768-8.452-12.849-14.458-19.373-19.145-5.807-3.8-11.028-5.983-14.191-12.545-.031-.069-.068-.145-.091-.213-2.065-5.3-.808-9.831-6.173-13.97-12.529-10.487-29.921,3.719-44.859,2.286-10.533-1.014-9.519-11.95-22-15.959-12.362-3.971-8.978,7.553-34.685-4.4a1.854,1.854,0,0,0-2.454.9h0a1.838,1.838,0,0,0,.259,1.951C1133.548,771.307,1124.562,778.486,1141.184,787.86Z",
    transform: "translate(-1115.918 -747.747)",
    fill: "#00ad9f"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_633",
    "data-name": "Group 633",
    transform: "translate(11.915 12.855)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_632",
    "data-name": "Group 632"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_490",
    "data-name": "Path 490",
    d: "M1131.733,765.327c7.995,4.588,12.644,12.972,19.693,18.688,3.369,2.728,7.339,4.939,11.722,5.343,4.794.442,9.8-1.692,14.435.267,3.582,1.517,6.1,4.695,9.367,6.707a10.755,10.755,0,0,0,5.625,1.692c2.607.023,5.167-.7,7.781-.61,4.062.137,7.728,2.058,10.937,4.428,3.414,2.523,6.417,5.548,9.656,8.277a48.052,48.052,0,0,0,24.952,10.952c1.151.145,2.309.244,3.468.3.343.015.244-.732-.038-.747a47.605,47.605,0,0,1-26.1-9.435c-3.384-2.546-6.379-5.571-9.633-8.277-3.026-2.515-6.394-4.878-10.274-5.815a17.794,17.794,0,0,0-6.478-.206c-2.492.313-5.022.724-7.469-.1-3.673-1.25-6.257-4.436-9.4-6.554a12.1,12.1,0,0,0-5.571-2.119,37.261,37.261,0,0,0-7.309.434,18.855,18.855,0,0,1-7-.48,21.657,21.657,0,0,1-5.99-2.82c-7.644-5.015-12.217-13.314-19.488-18.748a27.659,27.659,0,0,0-2.82-1.852c-.313-.206-.313.541-.061.678Z",
    transform: "translate(-1131.552 -764.613)",
    fill: "#4ca1ff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_648",
    "data-name": "Group 648",
    transform: "translate(409.219 487.134)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_635",
    "data-name": "Group 635",
    transform: "translate(0 87.853)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_491",
    "data-name": "Path 491",
    d: "M572.283,737.759s-49.249-10.769-87.127-6.722c-1.2.13.259-7.339.259-7.339s-7.8,8.284-9.771,8.6c-20.829,3.331-41.125,10.5-54.965,24.563,0,0,25.2-103.512,163.187-88.125Z",
    transform: "translate(-420.68 -667.173)",
    fill: "#5084da"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_636",
    "data-name": "Group 636",
    transform: "translate(35.759)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_492",
    "data-name": "Path 492",
    d: "M612.069,715.887s-22.064-9.908-49.607-31.415c-1.1-.861,3.895-7.469,3.895-7.469s-10.975,1.791-12.88.183c-31.567-26.56-67.685-67.563-85.877-125.286,0,0,30.234,1.28,72.547,16.729,1.8.655,6.638,9.687,6.638,9.687s1.966-6.409,3.559-5.769c38.777,15.616,85.793,42.984,128.693,90.854Z",
    transform: "translate(-467.6 -551.9)",
    fill: "#5193f4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_643",
    "data-name": "Group 643",
    transform: "translate(35.759 1.418)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_637",
    "data-name": "Group 637"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_493",
    "data-name": "Path 493",
    d: "M467.6,553.76a506.493,506.493,0,0,1,53.783,28.313c17.438,10.357,34.265,21.744,50.666,33.679,8.239,5.929,16.089,12.362,24.076,18.611l11.645,9.8c1.928,1.646,3.894,3.247,5.8,4.923l5.594,5.16c15.174,13.474,29.129,28.26,42.512,43.449l-10.723-10.761-5.335-5.4c-1.806-1.768-3.7-3.452-5.541-5.182L629.05,665.946l-11.394-10.007c-7.53-6.745-15.471-13-23.214-19.488-8.018-6.158-15.89-12.484-24.137-18.329-16.2-12.087-32.97-23.39-50.1-34.128q-12.827-8.082-25.989-15.647Q481.113,560.722,467.6,553.76Z",
    transform: "translate(-467.6 -553.76)",
    fill: "#5084da"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_638",
    "data-name": "Group 638",
    transform: "translate(55.011 61.495)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_494",
    "data-name": "Path 494",
    d: "M600.217,644.959c-5.015-1.219-10.014-2.309-15-3.407-5-1.052-9.992-2.042-15.006-2.858-5.015-.861-10.052-1.433-15.113-1.943-5.068-.412-10.144-.61-15.319-.594A67.1,67.1,0,0,1,555.2,634.45a102.256,102.256,0,0,1,15.486,1.334A108.812,108.812,0,0,1,600.217,644.959Z",
    transform: "translate(-539.78 -634.449)",
    fill: "#5084da"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_639",
    "data-name": "Group 639",
    transform: "translate(24.678 36.22)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_495",
    "data-name": "Path 495",
    d: "M542.3,603.9c-3.574-.213-7.118-.343-10.655-.473-3.536-.1-7.065-.16-10.594-.1-3.529.03-7.034.259-10.548.541-3.506.343-7,.838-10.525,1.486a46.429,46.429,0,0,1,10.312-3.064,70.421,70.421,0,0,1,10.731-1A75.03,75.03,0,0,1,542.3,603.9Z",
    transform: "translate(-499.98 -601.285)",
    fill: "#5084da"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_640",
    "data-name": "Group 640",
    transform: "translate(102.811 98.17)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_496",
    "data-name": "Path 496",
    d: "M658.844,693.148a98.405,98.405,0,0,0-13.673-4.664,89.4,89.4,0,0,0-14.038-2.606,84.8,84.8,0,0,0-14.259-.45,125.949,125.949,0,0,0-14.374,1.585,54.456,54.456,0,0,1,14.168-3.879,58.241,58.241,0,0,1,14.793-.183,60.617,60.617,0,0,1,14.4,3.346A48.9,48.9,0,0,1,658.844,693.148Z",
    transform: "translate(-602.5 -682.57)",
    fill: "#5084da"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_641",
    "data-name": "Group 641",
    transform: "translate(90.076 38.891)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_497",
    "data-name": "Path 497",
    d: "M611.161,637.9A190.038,190.038,0,0,0,599.6,620.459c-2.042-2.789-4.268-5.434-6.562-8.033-2.263-2.645-4.779-5.03-7.248-7.637a39.366,39.366,0,0,1,8.864,6,50.793,50.793,0,0,1,7.294,7.9,57.154,57.154,0,0,1,5.625,9.138A41.879,41.879,0,0,1,611.161,637.9Z",
    transform: "translate(-585.79 -604.79)",
    fill: "#5084da"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_642",
    "data-name": "Group 642",
    transform: "translate(131.902 65.048)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_498",
    "data-name": "Path 498",
    d: "M667.383,681.835c-1.905-3.834-3.879-7.583-5.807-11.325-1.982-3.719-3.978-7.416-6.128-11.013-2.119-3.612-4.428-7.1-6.821-10.54a126.3,126.3,0,0,0-7.957-9.847,46.825,46.825,0,0,1,9.755,8.406,74.42,74.42,0,0,1,7.56,10.472A79.22,79.22,0,0,1,667.383,681.835Z",
    transform: "translate(-640.67 -639.11)",
    fill: "#5084da"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_645",
    "data-name": "Group 645",
    transform: "translate(21.202 118.472)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_644",
    "data-name": "Group 644"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_499",
    "data-name": "Path 499",
    d: "M448.5,743.772c6.28-8.574,14.9-15.235,24.053-20.646a114.953,114.953,0,0,1,29.639-11.874l7.835-1.661c2.606-.579,5.274-.762,7.911-1.143a130.894,130.894,0,0,1,15.921-1.044c2.652-.168,5.312.1,7.964.191l7.949.389c5.266.671,10.517,1.395,15.73,2.218-5.3-.16-10.555-.6-15.807-.777l-7.888.03c-2.629.046-5.251-.091-7.865.213-5.228.488-10.472.579-15.631,1.54-2.576.434-5.205.61-7.751,1.2l-7.652,1.692a133.811,133.811,0,0,0-29.251,10.99,78.087,78.087,0,0,0-6.813,3.887c-1.105.7-2.233,1.372-3.315,2.111l-3.193,2.294A75.423,75.423,0,0,0,448.5,743.772Z",
    transform: "translate(-448.5 -707.349)",
    fill: "#4ca1ff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_647",
    "data-name": "Group 647",
    transform: "translate(92.69 119.845)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_646",
    "data-name": "Group 646"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_500",
    "data-name": "Path 500",
    d: "M555.988,709.15c-2.873,4.573-5.663,8.9-8,13.474a65.269,65.269,0,0,0-3.094,7.012,66.768,66.768,0,0,0-2.111,7.56c-1.273-5.343.122-11.081,2.576-15.913a36.481,36.481,0,0,1,4.565-6.752A27.764,27.764,0,0,1,555.988,709.15Z",
    transform: "translate(-542.3 -709.15)",
    fill: "#4ca1ff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_656",
    "data-name": "Group 656",
    transform: "translate(508.7 295.23)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_583",
    "data-name": "Path 583",
    d: "M0,0H81.563V56.093H0Z",
    transform: "translate(224.363 344.986)",
    fill: "#9e82ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_480",
    "data-name": "Rectangle 480",
    width: 81.563,
    height: 20.334,
    transform: "translate(224.363 344.986)",
    fill: "#605aca",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_501",
    "data-name": "Path 501",
    d: "M953.1,825.21H787.546a9.466,9.466,0,0,0,0,18.931H953.1a9.465,9.465,0,0,0,9.466-9.466h0A9.465,9.465,0,0,0,953.1,825.21Z",
    transform: "translate(-605.176 -425.008)",
    fill: "#9e82ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_502",
    "data-name": "Path 502",
    d: "M962.566,836.914a9.465,9.465,0,0,1-9.473,9.458H787.543a9.47,9.47,0,0,1-9.473-9.458,8.457,8.457,0,0,1,.3-2.294,9.43,9.43,0,0,0,9.168,7.172h165.55a9.431,9.431,0,0,0,9.168-7.172A7.908,7.908,0,0,1,962.566,836.914Z",
    transform: "translate(-605.173 -427.246)",
    fill: "#605aca",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_652",
    "data-name": "Group 652",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_650",
    "data-name": "Group 650"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_649",
    "data-name": "Group 649"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_503",
    "data-name": "Path 503",
    d: "M562.457,654.207a5.816,5.816,0,0,1-5.807-5.807V311.347a5.816,5.816,0,0,1,5.807-5.807h510.391a5.816,5.816,0,0,1,5.807,5.807V648.4a5.816,5.816,0,0,1-5.807,5.807Z",
    transform: "translate(-552.504 -301.394)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_504",
    "data-name": "Path 504",
    d: "M1071.554,308.392a1.665,1.665,0,0,1,1.661,1.661V647.105a1.665,1.665,0,0,1-1.661,1.661H561.163a1.665,1.665,0,0,1-1.661-1.661V310.053a1.665,1.665,0,0,1,1.661-1.661h510.391m0-8.292H561.163a9.956,9.956,0,0,0-9.953,9.953V647.105a9.956,9.956,0,0,0,9.953,9.953h510.391a9.956,9.956,0,0,0,9.953-9.953V310.053a9.961,9.961,0,0,0-9.953-9.953Z",
    transform: "translate(-551.21 -300.1)",
    fill: "#9e82ff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_651",
    "data-name": "Group 651",
    transform: "translate(0 313.365)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_505",
    "data-name": "Path 505",
    d: "M1081.5,744.225V711.27H551.21v32.955a11.221,11.221,0,0,0,11.226,11.226h507.838A11.221,11.221,0,0,0,1081.5,744.225Z",
    transform: "translate(-551.21 -711.27)",
    fill: "#9e82ff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_655",
    "data-name": "Group 655",
    transform: "translate(224.272 35.21)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_253",
    "data-name": "Ellipse 253",
    cx: 40.873,
    cy: 40.873,
    r: 40.873,
    fill: "#623cea"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_654",
    "data-name": "Group 654"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_653",
    "data-name": "Group 653",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_506",
    "data-name": "Path 506",
    d: "M907.471,382.759a15.8,15.8,0,1,1-15.8-15.8A15.8,15.8,0,0,1,907.471,382.759Zm8.04,68.988V411.034a8.73,8.73,0,0,0-8.726-8.726H876.566a8.73,8.73,0,0,0-8.726,8.726v40.713a2.417,2.417,0,0,0,2.416,2.416H913.1A2.417,2.417,0,0,0,915.511,451.747Z",
    transform: "translate(-850.799 -351.214)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_507",
    "data-name": "Path 507",
    d: "M961.343,504.475h-195.6A16.172,16.172,0,0,1,749.57,488.3h0a16.172,16.172,0,0,1,16.172-16.172h195.6A16.172,16.172,0,0,1,977.515,488.3h0A16.172,16.172,0,0,1,961.343,504.475Z",
    transform: "translate(-598.394 -341.021)",
    fill: "#623cea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_508",
    "data-name": "Path 508",
    d: "M960.4,496.254H778.382a4.222,4.222,0,0,1-4.222-4.222h0a4.222,4.222,0,0,1,4.222-4.222H960.4a4.222,4.222,0,0,1,4.222,4.222h0A4.222,4.222,0,0,1,960.4,496.254Z",
    transform: "translate(-604.243 -344.751)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_509",
    "data-name": "Path 509",
    d: "M961.543,580.815h-195.6a16.172,16.172,0,0,1-16.172-16.172h0a16.172,16.172,0,0,1,16.172-16.172h195.6a16.172,16.172,0,0,1,16.172,16.172h0A16.172,16.172,0,0,1,961.543,580.815Z",
    transform: "translate(-598.442 -359.18)",
    fill: "#623cea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510",
    "data-name": "Path 510",
    d: "M776.242,572.964h0a4.222,4.222,0,0,1-4.222-4.222h0a4.222,4.222,0,0,1,4.222-4.222h0a4.222,4.222,0,0,1,4.222,4.222h0A4.222,4.222,0,0,1,776.242,572.964Zm16.782-4.222h0a4.222,4.222,0,0,0-4.222-4.222h0a4.222,4.222,0,0,0-4.222,4.222h0a4.222,4.222,0,0,0,4.222,4.222h0A4.222,4.222,0,0,0,793.024,568.742Zm12.56,0h0a4.222,4.222,0,0,0-4.222-4.222h0a4.222,4.222,0,0,0-4.222,4.222h0a4.222,4.222,0,0,0,4.222,4.222h0A4.222,4.222,0,0,0,805.584,568.742Zm12.56,0h0a4.222,4.222,0,0,0-4.222-4.222h0a4.222,4.222,0,0,0-4.222,4.222h0a4.222,4.222,0,0,0,4.222,4.222h0A4.222,4.222,0,0,0,818.144,568.742Zm12.56,0h0a4.222,4.222,0,0,0-4.222-4.222h0a4.222,4.222,0,0,0-4.222,4.222h0a4.222,4.222,0,0,0,4.222,4.222h0A4.222,4.222,0,0,0,830.7,568.742Zm12.56,0h0a4.222,4.222,0,0,0-4.222-4.222h0a4.222,4.222,0,0,0-4.222,4.222h0a4.222,4.222,0,0,0,4.222,4.222h0A4.222,4.222,0,0,0,843.264,568.742Zm12.56,0h0a4.222,4.222,0,0,0-4.222-4.222h0a4.222,4.222,0,0,0-4.222,4.222h0a4.222,4.222,0,0,0,4.222,4.222h0A4.222,4.222,0,0,0,855.824,568.742Z",
    transform: "translate(-603.734 -362.998)",
    fill: "#5084da"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_511",
    "data-name": "Path 511",
    d: "M913.172,660.775H857.612A16.172,16.172,0,0,1,841.44,644.6h0a16.172,16.172,0,0,1,16.172-16.172h55.559A16.172,16.172,0,0,1,929.344,644.6h0A16.172,16.172,0,0,1,913.172,660.775Z",
    transform: "translate(-620.247 -378.2)",
    fill: "#623cea"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_512",
    "data-name": "Path 512",
    d: "M1132.2,739.259V720.77a11.013,11.013,0,0,0-11.013-11.013h-.96V692.625a45.674,45.674,0,1,0-91.349,0v17.133h-.96A11.013,11.013,0,0,0,1016.9,720.77v18.489Zm-88.232-46.635a30.584,30.584,0,1,1,61.169,0v17.133h-61.169Z",
    transform: "translate(-153.284 -87.375)",
    opacity: 0.09
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_513",
    "data-name": "Path 513",
    d: "M1170.675,526.112a29.147,29.147,0,0,0-16.538-6.547c-.023-.61-.015-1.2.008-1.982,3.376-.541,6.272-3.5,7.949-7.484,4.557-4.39,7.659-9.831,6.158-16.683a1.34,1.34,0,0,1,.168-1.006c-1.959-3.506-5.579-5.2-9.588-8.833-13.482-12.217-29.51,4.756-23.443,11.752a12.777,12.777,0,0,1,1.7,3.849c-.008.046-.031.069-.038.114a5.8,5.8,0,0,0,.991,4.611c.069.686.122,1.379.122,2.065a.761.761,0,0,1,.076.2,8.167,8.167,0,0,0,1.136,2.873c.815,3.262,2.766,6.692,6.874,8.071a9.973,9.973,0,0,0,.991.29,4.946,4.946,0,0,1,.145,2.2,26.45,26.45,0,0,0-10.792,3.612c-25.775,12.461-51.261,52.61-48.448,61.458s9.938,19.213,14.724,26.133l.755-.13c.389,1.334.77,2.667,1.158,4a2.761,2.761,0,0,0,3.582,2.385,4.949,4.949,0,0,0,3.224-.922,3.429,3.429,0,0,0,.937-1.715,7.254,7.254,0,0,0-.854-5.167l.564-.1s-11.112-16.63-10.708-26.766c.145-3.7,8.825-12.43,15.875-18.939-.16,2.256-.251,4.557-.251,6.89l-3.384,80.809s2.919.579,7.591,1.326l4.535,48.258h18.268l.434-45.461c.236.015.48.03.716.053l.632.046c.9.061,1.8.122,2.706.175.3.015.61.038.922.053.328.015.655.038.983.053l1.791,45.08h18.009l3.689-45.911a.222.222,0,0,0,.069-.015c.747-.122,1.479-.251,2.187-.4.313-.061.625-.137.93-.206.594-.13,1.181-.274,1.753-.427q.469-.126.915-.252c.572-.168,1.128-.351,1.669-.534.251-.084.511-.168.754-.259.762-.29,1.5-.594,2.187-.93l-.366-87.409c0-1.882-.061-3.719-.16-5.5-.008-.137-.015-.267-.031-.4-.107-1.669-.259-3.285-.457-4.862-.023-.16-.038-.312-.061-.472-.015-.145-.038-.29-.053-.427,3.567.709,8.2,1.555,14.259,2.584a25.877,25.877,0,0,0,11.44-.709V536.919C1194.019,538.641,1177.122,530.006,1170.675,526.112Z",
    transform: "translate(-170.18 -47.491)",
    opacity: 0.09
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_657",
    "data-name": "Group 657",
    transform: "translate(726.379 471.251)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_255",
    "data-name": "Ellipse 255",
    cx: 28.092,
    cy: 28.092,
    r: 28.092,
    fill: "#94ebff",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_256",
    "data-name": "Ellipse 256",
    cx: 15.243,
    cy: 15.243,
    r: 15.243,
    transform: "translate(12.849 12.849)",
    fill: "#94ebff",
    opacity: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_658",
    "data-name": "Group 658",
    transform: "translate(852.214 559.575)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_514",
    "data-name": "Path 514",
    d: "M1063.334,646.95a45.727,45.727,0,0,0-45.674,45.674v43.929h91.356V692.625A45.733,45.733,0,0,0,1063.334,646.95Zm-30.584,74.506V692.625a30.584,30.584,0,1,1,61.169,0v28.831Z",
    transform: "translate(-1005.679 -646.95)",
    fill: "#f9714e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_515",
    "data-name": "Path 515",
    d: "M1066.206,658.79a36.517,36.517,0,0,0-36.476,36.476v35.073h72.943V695.266A36.506,36.506,0,0,0,1066.206,658.79Zm30.584,65.482h-61.169V695.441a30.584,30.584,0,1,1,61.169,0Z",
    transform: "translate(-1008.55 -649.766)",
    fill: "#f9714e",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_516",
    "data-name": "Path 516",
    d: "M1112.091,821.341H1007.1a5.159,5.159,0,0,1-5.16-5.16V734.52a5.159,5.159,0,0,1,5.16-5.16h104.991a5.159,5.159,0,0,1,5.16,5.16v81.662A5.168,5.168,0,0,1,1112.091,821.341Z",
    transform: "translate(-1001.94 -666.553)",
    fill: "#ffb255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_517",
    "data-name": "Path 517",
    d: "M1089.118,776.109a16.759,16.759,0,1,0-24.472,14.869V809.1h15.433V790.978A16.741,16.741,0,0,0,1089.118,776.109Z",
    transform: "translate(-1014.704 -673.687)",
    fill: "#f9714e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_518",
    "data-name": "Path 518",
    d: "M1106.427,729.36h-27.7a172.583,172.583,0,0,1-27.437,52.145c-11.142,14.473-28.679,32.848-48.517,32.459a11.009,11.009,0,0,0,10.388,7.377h93.277a11.013,11.013,0,0,0,11.013-11.013V740.373A11.025,11.025,0,0,0,1106.427,729.36Z",
    transform: "translate(-1002.137 -666.553)",
    fill: "#ffb255",
    opacity: 0.4
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_663",
    "data-name": "Group 663",
    transform: "translate(906.372 431.785)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_519",
    "data-name": "Path 519",
    d: "M1092.21,646.178q1.1,3.8,2.195,7.6a2.761,2.761,0,0,0,3.582,2.385,4.949,4.949,0,0,0,3.224-.922,3.43,3.43,0,0,0,.937-1.715A7.449,7.449,0,0,0,1101.1,648a21.989,21.989,0,0,0-3.757-4.359",
    transform: "translate(-1077.57 -518.373)",
    fill: "#ffc2d3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_520",
    "data-name": "Path 520",
    d: "M1271.35,528.781a60.724,60.724,0,0,1,3.612-10.3c.785,1,.693,2.4.572,3.666a8.294,8.294,0,0,1,4.039-4.268.852.852,0,0,1,.686-.107.921.921,0,0,1,.419.655,11.694,11.694,0,0,1-6.974,13.711",
    transform: "translate(-1120.182 -488.423)",
    fill: "#ffc2d3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_521",
    "data-name": "Path 521",
    d: "M1170.34,842.01c6.455,1.57,11.851,3.475,14.816,6.128H1160.28l.473-5.769Z",
    transform: "translate(-1093.761 -565.559)",
    fill: "#5084da"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_522",
    "data-name": "Path 522",
    d: "M1128.946,842.01c-6.455,1.57-11.851,3.475-14.816,6.128h24.876l-.473-5.769Z",
    transform: "translate(-1082.784 -565.559)",
    fill: "#5084da"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_660",
    "data-name": "Group 660",
    transform: "translate(29.151 127.782)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_659",
    "data-name": "Group 659"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_523",
    "data-name": "Path 523",
    d: "M1171.756,650.674l-11.729,145.948a40.2,40.2,0,0,1-5.51,1,24.559,24.559,0,0,1-3.224-.45c-1.357-.274-2.545-.556-2.545-.556l-4.39-110.326h-5.51L1137.8,796.615a23.829,23.829,0,0,1-5.983.876,31.876,31.876,0,0,1-6.486-.876L1111.25,646.94Z",
    transform: "translate(-1111.25 -646.94)",
    fill: "#2e2c84"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_661",
    "data-name": "Group 661",
    transform: "translate(46.509 128.857)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_524",
    "data-name": "Path 524",
    d: "M1154.69,649.623l-20.654-1.273c-.251,26.88,3.788,122.939,4.207,149.446a24.689,24.689,0,0,0,4.977-.838l1.052-110.326h5.51l4.39,110.326s1.181.274,2.545.556c.4.069.808.145,1.212.206C1157.914,767.677,1155.208,661.977,1154.69,649.623Z",
    transform: "translate(-1134.025 -648.35)",
    fill: "#2e2c84",
    opacity: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_662",
    "data-name": "Group 662",
    transform: "translate(46.128)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_525",
    "data-name": "Path 525",
    d: "M1137.622,505.969a.765.765,0,0,1,.076.2c.892,4.824,5.464,7.3,10.556,8.7,4.138,1.143,5.1,1.646,8.422-.755,6.89-4.977,13.025-11.584,11.036-20.7a1.34,1.34,0,0,1,.168-1.006c-1.959-3.506-5.579-5.2-9.588-8.833-13.482-12.217-29.51,4.756-23.443,11.752C1135.838,496.457,1137.629,501.388,1137.622,505.969Z",
    transform: "translate(-1133.526 -479.276)",
    fill: "#001f64"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_526",
    "data-name": "Path 526",
    d: "M1177.283,576.926c0-27.742-11.485-45-33.473-45s-33.534,23.2-33.534,50.941l-3.376,80.809s51.269,10.167,70.756.655Z",
    transform: "translate(-1081.064 -491.8)",
    fill: "#8fc2ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_527",
    "data-name": "Path 527",
    d: "M1182.953,584.519a72.873,72.873,0,0,0-2.675-20.669c-1.951,30.188-4.6,110.577-49.538,110.25,16.706,2.088,40.622,3.666,52.579-2.18Z",
    transform: "translate(-1086.735 -499.393)",
    fill: "#8fc2ff",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_528",
    "data-name": "Path 528",
    d: "M1162.327,507.252c-.823-5.457-5.685-10.937-11.63-8.094-3.811,1.821-7.759,2.027-10.868.366-.091,1.052-.221,2.584-.335,4.192-.655-1.2-1.761-1.395-2.088.114-.35,1.616.084,4.618,1.822,5.182,0,.282-.008.564,0,.8.084,4.077,1.745,10.578,8.368,12.125.358,1.44.229,1.913-.183,3.834.366,1.28,5.518,2.1,7.217.594a31.116,31.116,0,0,1-.137-4.245c3.917-.625,7.187-4.489,8.665-9.45C1169.072,509.363,1164.849,503.319,1162.327,507.252Z",
    transform: "translate(-1088.294 -483.82)",
    fill: "#ffc2d3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_529",
    "data-name": "Path 529",
    d: "M1165.233,508.162a12.268,12.268,0,0,0-2.683-5.952c.16,9.488-3.872,18.306-13.04,20.341a9.526,9.526,0,0,0,1,.29c.358,1.44.229,1.913-.183,3.834.366,1.28,5.518,2.1,7.217.594a31.1,31.1,0,0,1-.137-4.245c3.917-.625,7.187-4.489,8.665-9.45C1171.978,510.273,1167.755,504.23,1165.233,508.162Z",
    transform: "translate(-1091.2 -484.731)",
    fill: "#ffc2d3",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_530",
    "data-name": "Path 530",
    d: "M1121.662,536.92c-25.775,12.461-51.261,52.61-48.449,61.458s9.938,19.213,14.724,26.133l9.367-1.646s-11.112-16.63-10.708-26.766c.251-6.257,24.83-26.85,24.83-26.85Z",
    transform: "translate(-1073 -492.987)",
    fill: "#8fc2ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_531",
    "data-name": "Path 531",
    d: "M1178.52,535.628c4.039,2.9,37.718,23.077,56.238,5.259,13.375-12.872,14.724-15.357,14.724-15.357l4.588,8.124s-20.928,36.94-46.254,32.665-25.966-5.586-25.966-5.586Z",
    transform: "translate(-1098.1 -490.278)",
    fill: "#8fc2ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_680",
    "data-name": "Group 680",
    transform: "translate(546.585 437.449)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_532",
    "data-name": "Path 532",
    d: "M624.813,693.863a40.557,40.557,0,0,0-23.016,17.4h68.416a40.557,40.557,0,0,0-23.016-17.4V526.24H624.82v2.736h-23.9V549.15h23.9v4.8h-23.9v20.174h23.9V693.863Z",
    transform: "translate(-600.92 -496.111)",
    opacity: 0.09
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_665",
    "data-name": "Group 665",
    transform: "translate(9.351 30.137)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_481",
    "data-name": "Rectangle 481",
    width: 28.664,
    height: 20.174,
    transform: "translate(33.957 22.907) rotate(180)",
    fill: "#ffb255"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_482",
    "data-name": "Rectangle 482",
    width: 28.664,
    height: 20.174,
    transform: "translate(33.957 47.885) rotate(180)",
    fill: "#ffb255"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_483",
    "data-name": "Rectangle 483",
    width: 7.309,
    height: 20.174,
    transform: "translate(33.952 22.907) rotate(180)",
    fill: "#ffc87c",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_484",
    "data-name": "Rectangle 484",
    width: 7.309,
    height: 20.174,
    transform: "translate(33.952 47.885) rotate(180)",
    fill: "#ffc87c",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_485",
    "data-name": "Rectangle 485",
    width: 22.376,
    height: 175.366,
    transform: "translate(51.564 175.366) rotate(180)",
    fill: "#ffb255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_533",
    "data-name": "Path 533",
    d: "M664.555,709.536h2.172a.628.628,0,0,0,.625-.625V534.795a.628.628,0,0,0-.625-.625h-2.172a.628.628,0,0,0-.625.625V708.911A.618.618,0,0,0,664.555,709.536Z",
    transform: "translate(-625.259 -528.134)",
    fill: "#ffc87c",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_664",
    "data-name": "Group 664",
    transform: "translate(0 166.022)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_534",
    "data-name": "Path 534",
    d: "M613.19,784.468a40.378,40.378,0,1,1,40.378,40.378A40.426,40.426,0,0,1,613.19,784.468Zm20.821,0a19.556,19.556,0,1,0,19.556-19.556A19.577,19.577,0,0,0,634.011,784.468Z",
    transform: "translate(-613.19 -744.09)",
    fill: "#ffb255"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_535",
    "data-name": "Path 535",
    d: "M638.01,790.372a21.462,21.462,0,1,0,21.462-21.462A21.488,21.488,0,0,0,638.01,790.372Zm1.905,0a19.556,19.556,0,1,1,19.556,19.556A19.577,19.577,0,0,1,639.915,790.372Z",
    transform: "translate(-619.094 -583.972)",
    fill: "#ffc87c",
    opacity: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_679",
    "data-name": "Group 679",
    transform: "translate(47.435)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_536",
    "data-name": "Path 536",
    d: "M812.286,554.455c-7.08,6.28-32.612,33.016-37.291,18.459-3.7-11.523-11.478-27.368-16.028-32.688a21.781,21.781,0,0,0-11.043-6.775v-1.844c4.428-.023,11.356-.884,11.348-16.843,0-4.824-.457-8-1.288-10.083,1.326-1.334,1.235-3.948.3-5.487-1.235-2.043-4.5-3.811-6.653-4.771-5.121-2.271-11.805-3.323-16.721-.145a21.184,21.184,0,0,0-6.173-5.4,14.857,14.857,0,0,0-6.745-2.172c-4.718-.091-8.818,3.529-11,7.713a17.214,17.214,0,0,0-1.867,11.1,12.4,12.4,0,0,0,6.6,8.871,5.89,5.89,0,0,0,3.262.64,6.79,6.79,0,0,0,3.757-2.271c2.523-2.622,2.949-5.746,4.8-8.589a3.072,3.072,0,0,1,1.029-.96,20.6,20.6,0,0,0-.869,5.678c-.046,5.5,1.89,10.853,4.436,15.73a9.092,9.092,0,0,0,2.637,3.445c1.151.8,4.131,1.585,5.35.8l-.511,3.91a28.241,28.241,0,0,0-10.38,3.033V535.8c-19.19,4.413-33.663,51.52-59.324,48.4v.061c-3.117-.869-6.547-1.12-6.73,1.936-.351,5.983,3.369,6.745,6.73,6.257v.122c10.746,0,24.99-3.1,37.5-16.927-6.9,38.914-4.146,89.87-4.146,89.87,1.852.267,3.689.511,5.525.732l3.14,35.652h16.34l.038-34.021c3.3.137,6.577.206,9.824.183l.381,33.839h18.954l3.666-35.485c3.361-.473,6.684-1.036,9.969-1.73-.678-21.4-.762-49.378-2.187-73.607a7.86,7.86,0,0,0,3.513,2.012c2.225.549,11.821,11.615,18.726,3.2,7-8.536,21.629-26.141,26.987-35.218C816.988,558.113,813.9,557.229,812.286,554.455Z",
    transform: "translate(-663.16 -486.708)",
    opacity: 0.09
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_537",
    "data-name": "Path 537",
    d: "M776.875,540.17l-1.075,8.254,8.681.953v-8.711Z",
    transform: "translate(-689.954 -499.425)",
    fill: "#f9acc8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_538",
    "data-name": "Path 538",
    d: "M685.691,618.635s-11.493-5.663-11.828,0c-.633,10.731,11.828,4.679,11.828,4.679Z",
    transform: "translate(-665.7 -517.491)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_539",
    "data-name": "Path 539",
    d: "M687.831,616.495s-11.493-5.663-11.828,0c-.633,10.731,11.828,4.679,11.828,4.679Z",
    transform: "translate(-666.209 -516.982)",
    fill: "#ffc2d3"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_666",
    "data-name": "Group 666",
    transform: "translate(79.079 14.201)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_540",
    "data-name": "Path 540",
    d: "M766.92,519.211c0,7.507,7.751,16.843,15.258,16.843,4.42,0,11.546-.663,11.546-16.843,0-17.011-5.7-13.589-13.208-13.589A13.593,13.593,0,0,0,766.92,519.211Z",
    transform: "translate(-766.92 -505.34)",
    fill: "#ffc2d3"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_541",
    "data-name": "Path 541",
    d: "M778.344,525.6c.023-6.31.831-13.81,3.163-19.922-.328.015-.663.023-1,.023a13.586,13.586,0,0,0-13.589,13.589c0,7.362,7.461,16.462,14.831,16.813C779.35,533.338,778.329,529.885,778.344,525.6Z",
    transform: "translate(-687.841 -491.221)",
    fill: "#ffc2d3",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_542",
    "data-name": "Path 542",
    d: "M789.372,507.441c-1.2.183-2.485-.4-3.612.061-1.806.732-1.928,3.483-3.59,4.5-2.081,1.265-5.213-.922-7.027.7-1.075.96-.945,2.645-.838,4.085a30.515,30.515,0,0,1-1.242,11.28c-.259.846.861,2.363.191,2.934-1.105.96-4.306.122-5.51-.716a9.194,9.194,0,0,1-2.637-3.475c-2.546-4.931-4.481-10.334-4.436-15.89s2.317-11.3,6.806-14.519c4.946-3.544,11.859-2.469,17.117-.114,2.164.968,5.419,2.759,6.653,4.824C792.466,503.119,792.275,507.014,789.372,507.441Z",
    transform: "translate(-686.354 -488.469)",
    fill: "#ffb255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_543",
    "data-name": "Path 543",
    d: "M790.315,499.3c-1.776,1.585-3.559,4.443-4.893,5.373-1.844,1.288-4.055,1.547-6.15,2.195-9.664,2.965-10.334,17.788-6.112,25.707a3.274,3.274,0,0,0,2.469-.343c.663-.579-.45-2.088-.191-2.934a30.679,30.679,0,0,0,1.242-11.28c-.114-1.44-.236-3.125.838-4.085,1.814-1.623,4.954.564,7.027-.7,1.669-1.014,1.791-3.765,3.59-4.5,1.128-.457,2.416.122,3.613-.061,2.9-.434,3.094-4.329,1.882-6.349A10.288,10.288,0,0,0,790.315,499.3Z",
    transform: "translate(-688.738 -489.703)",
    fill: "#ffc87c",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_544",
    "data-name": "Path 544",
    d: "M755.817,488.914a14.8,14.8,0,0,0-6.745-2.195c-4.718-.091-8.818,3.567-11,7.789a17.542,17.542,0,0,0-1.867,11.219,12.512,12.512,0,0,0,6.6,8.963,5.9,5.9,0,0,0,3.262.648,6.785,6.785,0,0,0,3.757-2.294c2.523-2.645,2.949-5.807,4.8-8.673,1.494-2.317,4.779-1.364,6.974-2.881C767.165,497.664,759.239,490.812,755.817,488.914Z",
    transform: "translate(-680.472 -486.71)",
    fill: "#ffb255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_545",
    "data-name": "Path 545",
    d: "M759.6,502.113c-1.014-.518-1.8-1.471-2.8-1.974-1.433-1.562-8.772-2.378-10.3,7.85a12.14,12.14,0,0,1-5.221,7.728,11.006,11.006,0,0,0,2.8,1.959,5.9,5.9,0,0,0,3.262.648,6.785,6.785,0,0,0,3.757-2.294c2.523-2.645,2.949-5.807,4.8-8.673,1.494-2.317,4.779-1.364,6.974-2.881a4.368,4.368,0,0,0,1.578-1.8A5.883,5.883,0,0,1,759.6,502.113Z",
    transform: "translate(-681.74 -489.681)",
    fill: "#ffc87c",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_546",
    "data-name": "Path 546",
    d: "M755.82,842.01c6.455,1.57,11.851,3.475,14.816,6.128H745.76l.473-5.769Z",
    transform: "translate(-682.808 -571.224)",
    fill: "#f9714e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_547",
    "data-name": "Path 547",
    d: "M785.08,842.01c6.455,1.57,11.851,3.475,14.816,6.128H775.02l.473-5.769Z",
    transform: "translate(-689.768 -571.224)",
    fill: "#f9714e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_548",
    "data-name": "Path 548",
    d: "M869.744,568.209a4.506,4.506,0,0,0-.518-.236c-.922-.252-1.8.4-2.568.968a43.612,43.612,0,0,0-5.045,4.352h.008a6.122,6.122,0,0,0-.968,1.075,4.018,4.018,0,0,0-.3,4.314,3.643,3.643,0,0,0,2.972,1.745,7.691,7.691,0,0,0,5.221-2.279,3.643,3.643,0,0,0,.221-4.436,3.573,3.573,0,0,0-2.286-1.882,19.382,19.382,0,0,0,2.972-2.187,1.76,1.76,0,0,0,.526-.678A.619.619,0,0,0,869.744,568.209Z",
    transform: "translate(-709.948 -506.025)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_669",
    "data-name": "Group 669",
    transform: "translate(150.291 59.994)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_667",
    "data-name": "Group 667",
    transform: "translate(0 3.778)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_549",
    "data-name": "Path 549",
    d: "M869.269,572.393a3.665,3.665,0,0,1-.221,4.436,7.691,7.691,0,0,1-5.221,2.279,3.643,3.643,0,0,1-2.972-1.745,4.034,4.034,0,0,1,.3-4.314C862.958,570.427,867.44,568.964,869.269,572.393Z",
    transform: "translate(-860.358 -570.384)",
    fill: "#ffc2d3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_668",
    "data-name": "Group 668",
    transform: "translate(1.754)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_550",
    "data-name": "Path 550",
    d: "M866.9,569.735a19.436,19.436,0,0,0,3.6-2.584,1.76,1.76,0,0,0,.526-.678.622.622,0,0,0-.236-.755,4.506,4.506,0,0,0-.518-.236c-.922-.252-1.8.4-2.568.968a43.608,43.608,0,0,0-5.045,4.352C863.552,571.069,866.074,570.185,866.9,569.735Z",
    transform: "translate(-862.66 -565.427)",
    fill: "#ffc2d3"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_670",
    "data-name": "Group 670",
    transform: "translate(103.04 53.503)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_551",
    "data-name": "Path 551",
    d: "M819.928,590.55c9.229-6.135,16.531-12.72,24.884-20.135a1.256,1.256,0,0,1,1.8.122c1.532,1.822,4.032,4.535,3.773,5.678a3.877,3.877,0,0,1-1.036,1.631q-11.695,12.964-23.4,25.928a25.759,25.759,0,0,1-5.03,4.657,8.6,8.6,0,0,1-6.547,1.379c-3.757-.93-5.853-4.794-7.9-8.079-10.075-16.188-8.422-22.033-7.187-27.025.854-3.468,1.936-6.89,2.568-10.411.2-1.113-2.462-7.309-.945-7.385,4.55,5.32,11.379,21.515,16.028,32.688A2.016,2.016,0,0,0,819.928,590.55Z",
    transform: "translate(-798.36 -556.91)",
    fill: "#f9714e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_678",
    "data-name": "Group 678",
    transform: "translate(51.817 135.493)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_671",
    "data-name": "Group 671"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_552",
    "data-name": "Path 552",
    d: "M731.15,667.889l11.729,133a43.522,43.522,0,0,0,5.51.915,26.14,26.14,0,0,0,3.224-.411c1.357-.252,2.546-.5,2.546-.5l.114-100.533h9.694L765.1,800.888a26.145,26.145,0,0,0,5.983.793,35.028,35.028,0,0,0,6.486-.793l14.076-136.4Z",
    transform: "translate(-731.15 -664.49)",
    fill: "#4b48b5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_672",
    "data-name": "Group 672",
    transform: "translate(30.165 13.36)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_553",
    "data-name": "Path 553",
    d: "M770.73,682.028c.069,4.5-.244,8.574,1.326,12.659a7.918,7.918,0,0,0,8,5.2c5.807-.114,9.839-3.285,9.854-9.146,0-.755.373-8.7.755-8.719Z",
    transform: "translate(-770.73 -682.02)",
    fill: "#568edb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_673",
    "data-name": "Group 673",
    transform: "translate(2.629 13.375)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_554",
    "data-name": "Path 554",
    d: "M734.6,682.04c.069,4.5-.13,8.566.983,12.667.869,3.2,2.82,5.3,5.594,5.236,4.047-.091,6.3-4.588,6.821-9.1.084-.747.221-8.7.488-8.719Z",
    transform: "translate(-734.6 -682.04)",
    fill: "#568edb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_674",
    "data-name": "Group 674",
    transform: "translate(0.169 7.879)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_555",
    "data-name": "Path 555",
    d: "M754.318,702.8a.068.068,0,0,0,.038-.008.244.244,0,0,0,.2-.282c-1.555-9.039-.488-26.332-.473-26.507a.23.23,0,0,0-.069-.183.273.273,0,0,0-.183-.069c-.16.008-15.647.732-22.155-.915a.247.247,0,0,0-.3.175.25.25,0,0,0,.175.3c6.089,1.539,19.914,1.029,22.026.945-.13,2.248-.96,17.88.5,26.354A.254.254,0,0,0,754.318,702.8Z",
    transform: "translate(-731.371 -674.828)",
    fill: "#5e9ce4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_675",
    "data-name": "Group 675",
    transform: "translate(24.032 5.295)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_556",
    "data-name": "Path 556",
    d: "M763.71,701.993h.023a.242.242,0,0,0,.221-.267,145.238,145.238,0,0,1-.343-26.2,205.715,205.715,0,0,0,33.366-3.6.248.248,0,0,0,.2-.282.245.245,0,0,0-.282-.2,204.486,204.486,0,0,1-33.5,3.6.234.234,0,0,0-.236.221,144.171,144.171,0,0,0,.32,26.507A.23.23,0,0,0,763.71,701.993Z",
    transform: "translate(-762.683 -671.438)",
    fill: "#5e9ce4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_676",
    "data-name": "Group 676",
    transform: "translate(17.443 35.539)",
    opacity: 0.16
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_557",
    "data-name": "Path 557",
    d: "M757.057,812.484c1.357-.252,2.546-.5,2.546-.5l.114-100.533h.815a.58.58,0,0,0-.815-.252c-1.905.854-2.8,2.172-3.978,3.727a7.736,7.736,0,0,0-1.517,4.367C753.445,750.279,755.251,773.866,757.057,812.484Z",
    transform: "translate(-754.037 -711.121)",
    fill: "#4e84d9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_677",
    "data-name": "Group 677",
    transform: "translate(45.208 7.497)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_558",
    "data-name": "Path 558",
    d: "M790.683,800.431a.241.241,0,0,1-.213-.267l.206-1.989a.235.235,0,0,1,.267-.213.241.241,0,0,1,.213.267l-.206,1.989a.247.247,0,0,1-.244.221A.028.028,0,0,0,790.683,800.431Zm.6-5.853a.241.241,0,0,1-.213-.267l.4-3.864a.223.223,0,0,1,.267-.213.241.241,0,0,1,.213.267l-.4,3.864a.242.242,0,0,1-.244.221A.028.028,0,0,0,791.285,794.578Zm.785-7.728a.241.241,0,0,1-.213-.267l.4-3.864a.242.242,0,1,1,.48.053l-.4,3.864a.247.247,0,0,1-.244.221C792.093,786.85,792.078,786.85,792.07,786.85Zm.793-7.728a.241.241,0,0,1-.213-.267l.4-3.864c.015-.13.145-.259.267-.213a.241.241,0,0,1,.213.267l-.4,3.864a.247.247,0,0,1-.244.221A.027.027,0,0,1,792.863,779.122Zm.793-7.72a.241.241,0,0,1-.213-.267l.4-3.864a.23.23,0,0,1,.267-.214.241.241,0,0,1,.213.267l-.4,3.864a.247.247,0,0,1-.244.221A.028.028,0,0,0,793.655,771.4Zm.785-7.728a.241.241,0,0,1-.213-.267l.4-3.864a.219.219,0,0,1,.267-.213.241.241,0,0,1,.213.267l-.4,3.864a.242.242,0,0,1-.244.221A.028.028,0,0,0,794.44,763.674Zm.793-7.728a.241.241,0,0,1-.213-.267l.4-3.864c.015-.13.145-.251.267-.213a.241.241,0,0,1,.213.267l-.4,3.864a.242.242,0,0,1-.244.221A.038.038,0,0,0,795.233,755.946Zm.785-7.728a.241.241,0,0,1-.213-.267l.4-3.864c.015-.13.137-.259.267-.214a.241.241,0,0,1,.213.267l-.4,3.864a.242.242,0,0,1-.244.221A.028.028,0,0,0,796.018,748.218Zm.793-7.72a.241.241,0,0,1-.213-.267l.4-3.864a.227.227,0,0,1,.267-.213.241.241,0,0,1,.213.267l-.4,3.864a.242.242,0,0,1-.244.221A.028.028,0,0,0,796.81,740.5Zm.785-7.728a.241.241,0,0,1-.213-.267l.4-3.864a.242.242,0,0,1,.244-.221h.023a.241.241,0,0,1,.213.267l-.4,3.864a.247.247,0,0,1-.244.221Zm.793-7.728a.241.241,0,0,1-.213-.267l.4-3.864c.015-.13.145-.259.267-.214a.241.241,0,0,1,.213.267l-.4,3.864a.247.247,0,0,1-.244.221A.028.028,0,0,0,798.388,725.042Zm.785-7.728a.241.241,0,0,1-.213-.267l.4-3.864a.23.23,0,0,1,.267-.214.241.241,0,0,1,.213.267l-.4,3.864a.247.247,0,0,1-.244.221C799.2,717.314,799.181,717.314,799.173,717.314Zm.793-7.72a.241.241,0,0,1-.213-.267l.4-3.864c.015-.13.13-.259.267-.213a.241.241,0,0,1,.213.267l-.4,3.864a.247.247,0,0,1-.244.221A.028.028,0,0,0,799.966,709.593Zm.793-7.728a.241.241,0,0,1-.213-.267l.4-3.864c.015-.13.145-.251.267-.213a.241.241,0,0,1,.213.267l-.4,3.864a.247.247,0,0,1-.244.221A.028.028,0,0,0,800.758,701.865Zm.785-7.728a.241.241,0,0,1-.213-.267l.4-3.864c.015-.13.145-.259.267-.213a.241.241,0,0,1,.213.267l-.4,3.864a.242.242,0,0,1-.244.221A.028.028,0,0,0,801.543,694.137Zm.793-7.728a.241.241,0,0,1-.213-.267l.4-3.864a.23.23,0,0,1,.267-.213.241.241,0,0,1,.213.267l-.4,3.864a.242.242,0,0,1-.244.221A.027.027,0,0,1,802.336,686.409Zm.785-7.728a.241.241,0,0,1-.213-.267l.4-3.864a.219.219,0,0,1,.267-.213.241.241,0,0,1,.213.267l-.4,3.864a.242.242,0,0,1-.244.221A.036.036,0,0,1,803.121,678.681Z",
    transform: "translate(-790.468 -674.328)",
    fill: "#5e9ce4"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_559",
    "data-name": "Path 559",
    d: "M744.164,551.15c-19.19,4.413-33.663,51.52-59.324,48.4v8.383c12.011,0,28.412-3.834,41.864-22.269C746.146,559.015,744.164,551.15,744.164,551.15Z",
    transform: "translate(-668.317 -502.037)",
    fill: "#f9714e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_560",
    "data-name": "Path 560",
    d: "M744.164,551.15c-19.19,4.413-33.663,51.52-59.324,48.4v8.383c12.011,0,28.412-3.834,41.864-22.269C746.146,559.015,744.164,551.15,744.164,551.15Z",
    transform: "translate(-668.317 -502.037)",
    fill: "#f9714e",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_561",
    "data-name": "Path 561",
    d: "M784.134,554.585c11.783,13.5,10.8,81.967,12.141,124.486-21.233,4.458-44.005,4.268-67.845.823,0,0-3.712-68.508,8.231-107.315C744.77,546.24,771.7,540.333,784.134,554.585Z",
    transform: "translate(-678.556 -501.059)",
    fill: "#f9714e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_562",
    "data-name": "Path 562",
    d: "M744.678,649.323a150.7,150.7,0,0,1-6.349-44.516c.038-12.712.351-26.514,3.689-39.067a41.851,41.851,0,0,0-5.358,11.287c-11.943,38.808-8.231,107.315-8.231,107.315a232.518,232.518,0,0,0,35.279,2.546C755.051,675.921,748.847,663.034,744.678,649.323Z",
    transform: "translate(-678.556 -505.507)",
    fill: "#f9714e",
    opacity: 0.3
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_681",
    "data-name": "Group 681",
    transform: "translate(447.094 396.341)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_563",
    "data-name": "Path 563",
    d: "M503.726,521.877c1.73-.091,13.535-8.841,18.085-11.783a12.542,12.542,0,0,0,3.475-2.934,4.388,4.388,0,0,0,.663-4.306,5.435,5.435,0,0,0-5.525-3.414c-5.884.015-7.926,1.943-10.784,4.9C500.175,514.126,503.726,521.877,503.726,521.877Z",
    transform: "translate(-478.155 -448.628)",
    fill: "#00ad9f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_564",
    "data-name": "Path 564",
    d: "M570.757,572.8c5.137,2.309,10.632,4.611,16.226,3.894,2.172-.274,4.535-1.265,5.259-3.323a4.865,4.865,0,0,0-1.631-5.022,11.554,11.554,0,0,0-5.061-2.279c-6.844-1.669-16.454-.747-23.23,1.181C562.32,567.242,567.693,571.419,570.757,572.8Z",
    transform: "translate(-492.247 -464.27)",
    fill: "#00ad9f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_565",
    "data-name": "Path 565",
    d: "M616.314,472.126c-2.294-1.448-4.824-3.384-4.824-6.1s2.835-4.794,5.556-4.809,5.243,1.471,7.286,3.262c8.65,7.591,7.576,16.256,7.576,16.256S618.867,473.742,616.314,472.126Z",
    transform: "translate(-503.944 -439.537)",
    fill: "#00ad9f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_566",
    "data-name": "Path 566",
    d: "M624.91,442.19c-2.012-.861-4.093-1.905-5.266-3.75a3.609,3.609,0,0,1-.549-3.041c.594-1.684,1.646-3.193,5.891-2.424,13.429,2.439,16.355,11.63,16.355,11.63S628.477,443.729,624.91,442.19Z",
    transform: "translate(-505.718 -432.769)",
    fill: "#00ad9f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_567",
    "data-name": "Path 567",
    d: "M678.39,465.756a21.216,21.216,0,0,0,14.343-7.355,13.122,13.122,0,0,0,2.881-5.335,5.859,5.859,0,0,0-1.57-5.617c-1.882-1.623-4.878-1.364-6.951.008A13.892,13.892,0,0,0,682.6,453.3C681.157,456.3,678.39,465.756,678.39,465.756Z",
    transform: "translate(-519.857 -435.994)",
    fill: "#00ad9f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_568",
    "data-name": "Path 568",
    d: "M532.737,661.2q-19.56-17.239-39.128-34.486c-6.951-6.128-14.046-12.43-18.451-20.585-9.466-17.529-4.009-40.3,8.772-55.575s31.5-24.3,50.3-30.866,38.381-11.173,56.306-19.853c11.241-5.442,22.544-13.558,25.63-25.661a25.608,25.608,0,0,0-23.291-31.88",
    transform: "translate(-470.377 -435.034)",
    fill: "none",
    stroke: "#086356",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_569",
    "data-name": "Path 569",
    d: "M682.918,455.42c-3.567,10.944-17.445,17.6-23.778,27.078",
    transform: "translate(-515.278 -438.157)",
    fill: "none",
    stroke: "#086356",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_570",
    "data-name": "Path 570",
    d: "M624.95,471.93c2.736,2.888,6.006,5.274,8.391,8.452,5.038,6.722,5.457,17.636-2,24.411",
    transform: "translate(-507.145 -442.084)",
    fill: "none",
    stroke: "#086356",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_571",
    "data-name": "Path 571",
    d: "M532.8,552.31c11.508,8.864,26.629,14.778,41.147,15.342",
    transform: "translate(-485.226 -461.204)",
    fill: "none",
    stroke: "#086356",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_572",
    "data-name": "Path 572",
    d: "M497.63,559.687c-5.3-15.624.472-34.334,13.65-44.257",
    transform: "translate(-476.395 -452.432)",
    fill: "none",
    stroke: "#086356",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_682",
    "data-name": "Group 682",
    transform: "translate(922.731 279.627)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_573",
    "data-name": "Path 573",
    d: "M1096.4,289.74c-.625-1.936-.594-4.306.831-5.754a4.21,4.21,0,0,1,4.5-1.006c11.409,5.03,10.175,22.879,10.175,22.879S1101.086,304.289,1096.4,289.74Z",
    transform: "translate(-1094.833 -280.356)",
    fill: "#00ad9f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_574",
    "data-name": "Path 574",
    d: "M1095.757,334.509c-7.377,13.375,18.847,12.354,28.305,4.481C1124.063,338.99,1102.113,322.993,1095.757,334.509Z",
    transform: "translate(-1094.466 -291.69)",
    fill: "#00ad9f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_575",
    "data-name": "Path 575",
    d: "M1139.151,290.025c-1.783-2.446-2.416-6.1-.472-8.422a6.46,6.46,0,0,1,6.166-1.837,14.425,14.425,0,0,1,6.928,4.237c8.627,10.769,4.573,21.309,4.573,21.309S1142.062,294.033,1139.151,290.025Z",
    transform: "translate(-1104.699 -279.627)",
    fill: "#00ad9f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_576",
    "data-name": "Path 576",
    d: "M1276.21,334.467c-.64-2.081-.488-4.626,1.128-6.082a5.129,5.129,0,0,1,3.833-1.151,11.736,11.736,0,0,1,3.925,1.174,12.526,12.526,0,0,1,6.036,6.021c3.247,6.7,1.044,15,1.044,15S1277.8,339.657,1276.21,334.467Z",
    transform: "translate(-1137.614 -290.947)",
    fill: "#00ad9f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_577",
    "data-name": "Path 577",
    d: "M1226.366,367.662a16.79,16.79,0,0,0-17.392-2.8,8.923,8.923,0,0,0-3.719,2.8c-2.073,2.873-1.349,7.073.808,9.892s5.411,4.527,8.627,5.99c5.838,2.66,14.892,3.186,21.1,4.779C1235.794,388.315,1235.771,375.946,1226.366,367.662Z",
    transform: "translate(-1120.526 -299.593)",
    fill: "#00ad9f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_578",
    "data-name": "Path 578",
    d: "M1107.25,295.71c3.856,12.667,14.778,22.224,26.934,27.4s25.547,6.539,38.724,7.393,26.515,1.28,39.257,4.748c12.423,3.384,24.785,10.426,30.119,22.178,6.486,14.3.739,31.4-8.368,44.181s-21.37,23.085-30.18,36.072c-4.047,5.967-7.423,12.949-6.608,20.113,1.09,9.557,9.115,16.592,16.576,22.635",
    transform: "translate(-1097.507 -283.452)",
    fill: "none",
    stroke: "#086356",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_579",
    "data-name": "Path 579",
    d: "M1147.1,289.61c8.734,9.694,15.715,24.845,17.415,37.794",
    transform: "translate(-1106.986 -282.001)",
    fill: "none",
    stroke: "#086356",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_580",
    "data-name": "Path 580",
    d: "M1108.58,337.543c4.992,1.326,10.052,2.667,15.22,2.683s11.15-2.858,14.862-6.455",
    transform: "translate(-1097.823 -292.506)",
    fill: "none",
    stroke: "#086356",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_581",
    "data-name": "Path 581",
    d: "M1287.54,337.76a25.9,25.9,0,0,1,7.766,17.438c.244,6.516-3.361,14.419-7.69,19.289",
    transform: "translate(-1140.392 -293.455)",
    fill: "none",
    stroke: "#086356",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_582",
    "data-name": "Path 582",
    d: "M1223.31,376.58a260.287,260.287,0,0,0,27.864,22.932c4.74,3.346,14.153,7.637,18.337,6.531",
    transform: "translate(-1125.114 -302.689)",
    fill: "none",
    stroke: "#086356",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogin);
export default __webpack_public_path__ + "static/media/login.7343adac96ebc5359d091c132444ad02.svg";
export { ForwardRef as ReactComponent };